'use client';

import { __styles, mergeClasses } from "@griffel/react";
export const navClassNames = {
  root: 'fui-Nav'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f22iagw",
    Beiy3e4: "f1vx9l62"
  }
}, {
  d: [".f22iagw{display:flex;}", ".f1vx9l62{flex-direction:column;}"]
});
/**
 * Apply styling to the Nav slots based on the state
 */
export const useNavStyles_unstable = state => {
  const styles = useStyles();
  // eslint-disable-next-line react-hooks/immutability
  state.root.className = mergeClasses(navClassNames.root, styles.root, state.root.className);
  // TODO Add class names to slots, for example:
  // state.mySlot.className = mergeClasses(styles.mySlot, state.mySlot.className);
  return state;
};